import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ShieldCheck } from "lucide-react";
import { Layout } from "../components/Layout";

const CopyrightPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Copyright Policy · CurioVault";
    return () => { document.title = "CurioVault"; };
  }, []);

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="copyright-policy-page">
        <nav className="flex items-center gap-2 font-mono-cv text-xs text-[#7A6C5D] mb-8" data-testid="breadcrumb">
          <Link to="/" className="hover:text-[#9E4535]">Vault</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#1A1615]">Copyright Policy</span>
        </nav>

        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 shrink-0 rounded-full border-2 border-[#C5A059] flex items-center justify-center text-[#9E4535]">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <div>
            <p className="caption-label mb-1">Intellectual Property</p>
            <h1 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#1A1615] leading-tight">Copyright Policy</h1>
          </div>
        </div>

        <div className="bg-white border border-[#D8CEB9] rounded-sm p-7 sm:p-9">
          <p className="font-body text-base sm:text-lg text-[#2E282A] leading-[1.85] drop-cap">
            All curios on CurioVault are researched from multiple sources and rewritten in
            original language. We respect intellectual property. If you believe content
            infringes copyright, contact us at{" "}
            <a href="mailto:contact@curiovault.co" data-testid="copyright-contact-email" className="text-[#9E4535] hover:underline">contact@curiovault.co</a>{" "}
            for immediate removal. Sources are listed for verification, not as a source of
            copied text.
          </p>
        </div>

        <div className="mt-8 bg-[#FDF8ED] border border-[#E4D3A8] rounded-sm p-6">
          <p className="caption-label !text-[#B08A42] mb-2">Our Originality Standard</p>
          <p className="font-body text-sm text-[#4A4036] leading-relaxed">
            Every entry is written in original words. Facts themselves are not
            copyrightable, but our wording is. If you reuse our phrasing, please credit
            CurioVault.co and link back to the relevant page.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default CopyrightPolicy;
